import lotr from '../images/lotr.jpg';
import starWars from '../images/sw_image.png';

// The virtual backgrounds on offer in a meeting.
//
// Drawn from the app's own theme artwork rather than from stock scenery: these
// files are already in the bundle (themes.css uses lotr.jpg as the Mordor
// theme's --backdrop-image), so the feature costs no new download, and a
// Cyclone meeting ends up offering backgrounds that are recognisably Cyclone's
// instead of the same beach every other call app ships.
//
// `id` - not the webpack-hashed URL - is what travels between participants in
// together mode: the hash differs between builds, so sending it would break
// the moment two people were on different versions.
export const MEETING_SCENES = [
    { id: 'mordor', src: lotr, labelKey: 'meeting.background.scenes.mordor' },
    { id: 'space', src: starWars, labelKey: 'meeting.background.scenes.space' }
];

export function sceneById(id) {
    return MEETING_SCENES.find((scene) => scene.id === id) || null;
}
